const downloadResource = async (resourceUrlPromise) => {
  if (resourceUrlPromise) {
    const resourceUrlResponse = await resourceUrlPromise;
    window.open(resourceUrlResponse, '_blank');
  }
};

export default downloadResource;
